import { BrandLocationData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { CA_LIGHT_BLUE_COLOR } from '@utils/colorGenerator';
import { baseChart } from './baseChart';
import mapData from '@highcharts/map-collection/countries/us/us-all.topo.json';
import Highcharts from 'highcharts';

export const buildChartOptions = (
  sortedDataItems: BrandLocationData[]
): Highcharts.Options => {
  const indexByState = sortedDataItems.reduce(
    (acc, item) => {
      const value = acc[item.state] ?? 0;
      acc[item.state] = value + item.index;
      return acc;
    },
    {} as Record<string, number>
  );

  return {
    ...baseChart,

    chart: {
      map: 'countries/us/us-all',
    },

    plotOptions: {
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
        },
      },
    },

    series: [
      {
        type: 'map',
        name: 'Basemap',
        mapData,
      },
      {
        type: 'mapbubble',
        color: CA_LIGHT_BLUE_COLOR,
        data: Object.entries(indexByState).map(([state, index]) => ({
          z: index,
          stateAbbreviation: state,
        })),
        joinBy: ['postal-code', 'stateAbbreviation'],
        mapData,
        maxSize: '10%',
        marker: {
          lineWidth: 0,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
    ],

    tooltip: {
      enabled: true,
      headerFormat: '',
      pointFormat: '{point.stateAbbreviation}: {point.z}',
    },

    xAxis: undefined,
  };
};
